import { paginationFactory, priceFactory } from 'factories';
import { PerformanceReport, PerformanceReportEntry } from 'types';
import { convertTimestampToDate } from 'helpers';

function populatePerformanceEntriesData(
  entriesData: any
): PerformanceReportEntry[] {
  const entries = entriesData || [];

  return entries.map((entry: any) => {
    const {
      consignmentCode,
      createdDate,
      availableDate,
      salesMode,
      totalPrice,
      actionDate,
      action,
      actionTime,
      reasonOfRevokeDescription,
    } = entry || {};

    return {
      consignmentCode: consignmentCode || '',
      createdDate: convertTimestampToDate(createdDate || 0),
      availableDate: convertTimestampToDate(availableDate || 0),
      salesMode: salesMode || '',
      totalPrice: priceFactory(totalPrice),
      actionDate: convertTimestampToDate(actionDate || 0),
      action: action || '',
      actionTime: actionTime || 0,
      reasonOfRevokeDescription: reasonOfRevokeDescription || '',
    };
  });
}

export function performanceGetFactory(params: any = {}): PerformanceReport {
  const { pagination, results } = params;

  return {
    pagination: paginationFactory(pagination),
    results: populatePerformanceEntriesData(results),
  };
}
